import { ApiClient } from 'lib/api-clients';
import { ApiClientResponse } from 'type/api';
import { SiteDutyConfig } from 'page/Settings/page/RosterSettings/pages/Duties/types';

export interface Duty {
  id: string;
  name: string;
  description?: string;
}

export type UnmetDuty = {
  dutyId: string;
  name: string;
  key: string;
  required: number;
  assigned: number;
};

export type UnmetDate = {
  date: string;
  dayOfWeek: string;
  missingCount: number;
  duties: UnmetDuty[];
};

export type ComplianceCheckResponse = {
  isCompliant: boolean;
  unmetDates: UnmetDate[];
};

export const DutiesApi = {
  getDuties: (): Promise<ApiClientResponse<Duty[]>> =>
    ApiClient.get('/api/health-safety/duties'),

  getRequirements: (
    siteId: string,
    dayOfWeek?: string
  ): Promise<ApiClientResponse<SiteDutyConfig[]>> =>
    ApiClient.get(`/api/health-safety/site/${siteId}/requirements`,
      dayOfWeek ? { day: dayOfWeek } : {}
    ),

  saveRequirements: (
    siteId: string,
    data: any
  ): Promise<ApiClientResponse<SiteDutyConfig[]>> =>
    ApiClient.put(`/api/health-safety/site/${siteId}/requirements`, data),

  checkCompliance: (
    siteId: string,
    rosterIds: string[]
  ): Promise<ApiClientResponse<ComplianceCheckResponse>> =>
    ApiClient.post('/api/roster/publish/check-duties', {
      site_id: siteId,
      roster_ids: rosterIds,
    }),
};